export default {
  Calendar: {
    Title: 'Lịch học',
    Create: 'Thêm lịch học'
  }
}
